import { SnippetsOutlined } from '@ant-design/icons';
import { Badge, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';

interface NoteCellProps {
  length?: number;
  onClick: () => void;
}

const MAX_BADGE_COUNT = 99;

const NoteCell: FC<NoteCellProps> = ({ length = 0, onClick }) => {
  const { t } = useTranslation();
  const hasNotes = length > 0;
  const tooltipTitle = hasNotes
    ? t('labels.keynoteCount', { count: length })
    : t('labels.keyNote');
  const actionLabel = hasNotes
    ? t('labels.viewKeynoteCount', { count: length })
    : t('labels.viewKeynote');

  return (
    <div className={s.note}>
      <div className={s.actions}>
        <Tooltip title={tooltipTitle} placement="bottom">
          <Badge
            count={length}
            overflowCount={MAX_BADGE_COUNT}
            size="small"
            className={s.badge}
          >
            <button
              type="button"
              className={s['action-button']}
              onClick={onClick}
              aria-label={actionLabel}
            >
              <span className={s['action-icon']} aria-hidden>
                <SnippetsOutlined />
              </span>
            </button>
          </Badge>
        </Tooltip>
      </div>
    </div>
  );
};

export default NoteCell;
